import { departmentActionType } from '../../constants/index';

export default (state = {}, action) => {
    switch (action.type) {
        case departmentActionType.FETCH_DEPARTMENTS_ALL:
            return {
                ...state,
                "departmentsAll": action.payload
            };
        case departmentActionType.FETCH_DEPARTMENTS_SUCCESS:
            return {
                ...state,
                "departmentsClassAPISuccess": action.payload
            };
        default:
            return state;
    }
};
